@if (profile()) {
  <div class="px-2 px-lg-4 pt-2 pt-lg-3">
    <h5 class="small-caps"
        i18n>Configuration</h5>
    <table class="table table-sm table-list mb-4">
      <thead>
        <tr>
          <th colspan="2"
              scope="col"></th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <th title="A description of the profile, shown on the Detail screen for the profile. This should be descriptive enough to help the user decide whether to install the profile."
              data-toggle="tooltip"
              data-placement="right"
              scope="row">
            Description
          </th>
          <td>{{ profile()?.payloadDescription }}</td>
        </tr>
        <tr>
          <th title="A human-readable name for the profile. This value is displayed on the Detail screen. It does not have to be unique."
              data-toggle="tooltip"
              data-placement="right"
              scope="row">
            Display name
          </th>
          <td>{{ profile()?.payloadDisplayName }}</td>
        </tr>
        <tr>
          <th title="A date on which a profile is considered to have expired and can be updated over the air. This key is only used if the profile is delivered via over-the-air profile delivery."
              data-toggle="tooltip"
              data-placement="right"
              scope="row">
            Expiration date
          </th>
          <td>{{ profile()?.payloadExpirationDate }}</td>
        </tr>
        <tr>
          <th title="A reverse-DNS style identifier (com.example.myprofile, for example) that identifies the profile. This string is used to determine whether a new profile should replace an existing one or should be added."
              data-toggle="tooltip"
              data-placement="right"
              scope="row">
            Identifier
          </th>
          <td>{{ profile()?.payloadIdentifier }}</td>
        </tr>
        <tr>
          <th title="A human-readable string containing the name of the organization that provided the profile."
              data-toggle="tooltip"
              data-placement="right"
              scope="row">
            Organization
          </th>
          <td>{{ profile()?.payloadOrganization }}</td>
        </tr>
        <tr>
          <th title="A globally unique identifier for the profile. The actual content is unimportant, but it must be globally unique."
              data-toggle="tooltip"
              data-placement="right"
              scope="row">
            UUID
          </th>
          <td>{{ profile()?.payloadUUID }}</td>
        </tr>
        <tr>
          <th title="Supervised only. If present and set to true, the user cannot delete the profile (unless the profile has a removal password and the user provides it)."
              data-toggle="tooltip"
              data-placement="right"
              scope="row">
            Removal disallowed
          </th>
          <td><ml-yes-no-icon [flag]="profile()?.payloadRemovalDisallowed"></ml-yes-no-icon></td>
        </tr>
        <tr>
          <th title="The only supported value is Configuration."
              data-toggle="tooltip"
              data-placement="right"
              scope="row">
            Type
          </th>
          <td>{{ profile()?.payloadType }}</td>
        </tr>
        <tr>
          <th title="The version number of the profile format. This describes the version of the configuration profile as a whole, not of the individual profiles within it.
            Currently, this value should be 1."
              data-toggle="tooltip"
              data-placement="right"
              scope="row">
            Version
          </th>
          <td>{{ profile()?.payloadVersion }}</td>
        </tr>
        <tr>
          <th title="The date on which the profile will be automatically removed."
              data-toggle="tooltip"
              data-placement="right"
              scope="row">
            Removal date
          </th>
          <td>{{ profile()?.removalDate }}</td>
        </tr>
        <tr>
          <th title="Number of seconds until the profile is automatically removed. If the RemovalDate keys is present, whichever field yields the earliest date will be used."
              data-toggle="tooltip"
              data-placement="right"
              scope="row">
            Duration until removal
          </th>
          <td>{{ profile()?.durationUntilRemoval }}</td>
        </tr>
      </tbody>
    </table>
  </div>
}